<template>
  <div class="find">
    <!-- 选项卡菜单 -->
    <div class="tabMenu_find flex justify-center">
      <div class="flex">
        <span @click="checkTab(0)" :class="{ active: tabIndex === 0 }"
          >大厅</span
        >
        <span @click="checkTab(1)" :class="{ active: tabIndex === 1 }"
          >分类</span
        >
      </div>
    </div>

    <div v-if="tabIndex === 0" class="livePage">
      <!-- 热门话题 -->
      <div class="floor">
        <ul class="anchor-list2" style="padding-top: 1rem">
          <li class="topic">
            <a href="javascript:void(0)" class="item">
              <p>热门话题</p>
              <i></i>
            </a>
          </li>
          <li
            v-for="item in topicList"
            :key="item.id"
            @click="jumpPage3(item.id)"
          >
            <a href="javascript:void(0)" class="item item_a">
              <van-image
                class="bgimg"
                lazy-load
                fit="cover"
                width="100%"
                height="100%"
                :src="item.image ? item.image : ''"
              />
              <span
                class="bg"
                :style="{ 'background-color': cutColor(item.color) }"
              ></span>
              <div class="info">
                <p>{{ item.title }}</p>
                <span>{{ item.join_num }}人参与</span>
              </div>
            </a>
          </li>
          <li v-if="topicList.length > 5" class="hotTopic" @click="jumpPage2()">
            <div>
              <p class="title van-multi-ellipsis--l2">更多</p>
              <p>......</p>
            </div>
          </li>
        </ul>
      </div>
      <!-- 精选推荐 -->
      <div class="floor" v-if="empty">
        <div class="living2 title" style="padding-left: 1.25rem">
          <span>精选推荐</span>
          <a href="javascript:void(0)" @click="goRecomment">更多</a>
        </div>
        <ul v-if="!empty" class="anchor-list2" style="margin-top: 1.75rem">
          <li v-for="item in commendList" :key="item.id">
            <a href="#" class="s_item">
              <div>
                <img :src="item.image" alt="" />
                <div class="s_user">
                  <img :src="item.user.image" alt="" />
                  <span>{{ item.user.nickname }}</span>
                </div>
              </div>
              <span>{{ item.content }}</span>
            </a>
          </li>
        </ul>
      </div>
      <!-- 最新晒照 -->
      <div class="floor" style="margin-top: 30px">
        <p class="title" style="padding-left: 1.25rem">最新晒照</p>
        <div class="shaizhaoList">
          <waterfall
            :col="col"
            :data="newShowList"
            :width="itemWidth"
            :gutterWidth="gutterWidth"
            @loadmore="loadmore"
            @scroll="scroll"
          >
            <template>
              <div v-for="item in newShowList" :key="item.id">
                <WaterfallList :data="item" />
              </div>
            </template>
          </waterfall>
          <div class="no-more" v-show="!newEmpty">加载中...</div>
          <div class="no-more" v-show="newEmpty">没有更多了</div>
        </div>
      </div>
      <div @click="jumpDown" class="photoBtn"></div>
    </div>
    <div v-if="tabIndex === 1" class="livePage2 sort">
      <EmptyList v-if="findEmpty" :style="{ background: 'transparent' }" />
      <div v-if="!findEmpty">
        <a
          v-for="item in plateList"
          :key="item.id"
          href="javascript:void(0)"
          @click="jumpPage(item.id, item.title)"
          class="sort-item"
        >
          <p>{{ item.title }}</p>
          <img :src="item.image" alt="" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { WaterfallList, EmptyList } from "@/components";
import {
  getTopicList2,
  getCommendList,
  getNewShowImage,
  getShowImagePlate,
} from "@/request/api";
import Contents from "@/request/base.default.js";
import { navigate, checkWx } from "@/pages/index/custom";

export default {
  components: {
    WaterfallList,
    EmptyList,
  },
  data() {
    return {
      tabIndex: 0, // 头部索引
      topicList: [], // 话题列表
      commendList: [], // 精选推荐列表
      newShowList: [], // 最新晒照列表
      col: 2, // 瀑布流列数
      page: 1, // 瀑布流分页
      plateList: [], // 分类板块列表
      empty: false,
      newEmpty: false,
      findEmpty: false,
    };
  },

  methods: {
    // 标签切换
    checkTab(index) {
      this.tabIndex = index;
    },
    // 跳转晒照页
    jumpPage(id, title) {
      navigate({ path: "/main/findList", query: { id: id, name: title } });
    },
    // 跳转到话题列表
    jumpPage2() {
      navigate({ path: "topicList" });
    },
    // 跳转到话题详情页
    jumpPage3(id) {
      navigate({ path: "/main/topicDetails", query: { id: id } });
    },
    // 跳转到精选推荐
    goRecomment() {
      navigate({ path: "recommend" });
    },
    jumpDown() {
      if (checkWx()) {
        navigate("", Contents.downURL + "?mini=1");
      } else {
        navigate("", Contents.downURL);
      }
    },
    // 获取话题列表
    initTopicList() {
      getTopicList2({
        page: 1,
        pcount: 5,
      })
        .then((res) => {
          let { data, error_code } = res;
          if (error_code === 0) {
            this.topicList = data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 获取精选推荐列表
    initCommendList() {
      getCommendList()
        .then((res) => {
          let { data, error_code } = res;
          if (error_code === 0) {
            if (data.length === 0 || !data) {
              this.finished = true;
              return false;
            }
            this.commendList = data;
            if (this.commendList.length <= 0) {
              this.empty = true;
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 获取晒照分类板块儿
    initShowImagePlate() {
      getShowImagePlate()
        .then((res) => {
          let { data, error_code } = res;
          if (error_code === 0) {
            if (data && data.length > 0) {
              this.plateList = data;
            } else {
              this.findEmpty = true;
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 获取最新晒照
    initNewShowPhoto() {
      getNewShowImage({
        page: this.page,
        pcount: 8,
      })
        .then((res) => {
          let { posts, error_code } = res;
          if (error_code === 0) {
            if (posts.length > 0) {
              this.newShowList = this.newShowList.concat(posts);
              this.page = this.page + 1;
            } else {
              this.newEmpty = true;
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    scroll(scrollData) {
      // console.log(scrollData)
    },
    switchCol(col) {
      this.col = col;
    },
    loadmore(index) {
      this.initNewShowPhoto();
    },
    cutColor(color) {
      return "#" + color.substring(3);
    },
  },
  computed: {
    itemWidth() {
      return Math.floor((document.documentElement.clientWidth - 55) / 2);
    },
    gutterWidth() {
      return 15;
    },
  },
  created() {
    this.initTopicList();
    this.initCommendList();
    this.initNewShowPhoto();
    this.initShowImagePlate();
  },
};
</script>

<style lang="less" scoped>
.info {
  display: inline-block;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 0.5rem;
  border-radius: 0.375rem;
  position: relative;
  z-index: 400;
}
.item_a {
  padding: 0 !important;
}
.bgimg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 200;
  border-radius: 0.375rem;
  overflow: hidden;
}
.bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 300;
  opacity: 0.7;
  border-radius: 6px;
  overflow: hidden;
}
.find {
  background-color: #f8f8f8;
  width: 100%;
  height: 100%;
  padding-top: 7.5rem;
}
.no-more {
  text-align: center;
  height: 1.875rem;
  color: #ccc;
  font-size: 14px;
}
.tabMenu_find {
  padding-top: 16px;
  padding-bottom: 12px;
  background-color: #fff;
  position: fixed;
  top: 3.75rem;
  left: 0;
  background-color: #fff;
  z-index: 2333;
  width: 100%;
  & > div {
    box-sizing: border-box;
    border: 1px solid #eb5a6a;
    border-radius: 6px;
    overflow: hidden;
  }
  span {
    height: 30px;
    width: auto;
    line-height: 30px;
    padding: 0 16px;
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    color: #eb5a6a;
  }
  span.active {
    background-color: #eb5a6a;
    color: #fff;
  }
}
@import "./find.less";
</style>